import { useState } from "react";
import VisitorList from "../VisitorsList";
import AddVisitor from "../AddVisitor";
import Modal from "@/common/elements/Modal";

const VisitorLogDetails = ({}) => {
  const [showAddVisitor, setShowAddVisitor] = useState(false);

  const switchToAddVisitor = () => {
    setShowAddVisitor(!showAddVisitor);
  };

  return (
    <>
      <VisitorList switchToAddVisitor={switchToAddVisitor} isBookings={true}/>

      <Modal
        header="Add Visitor"
        show={showAddVisitor}
        size="xl"
        onHide={switchToAddVisitor}
      >
        <AddVisitor onHide={switchToAddVisitor}/>
      </Modal>
    </>
  );
};
export default VisitorLogDetails;
